const msalScopes = [
    "offline_access",
    "openid",
    "profile",
    "people.read",
    "group.read.all",
    "user.read",
    "user.read.all",
    "user.readbasic.all",
    "mail.send",
    "email",
    "calendars.read",
    "calendars.readwrite",
    "sites.read.all",
    "sites.readwrite.all",
    "userauthenticationmethod.read.all",
    "directory.read.all",
    "presence.read.all"
];

export {
    msalScopes
}